@if (cycle()) {
  <div
    class="border rounded-3 mb-2 overflow-hidden"
    [ngClass]="[resolvedCycleIndex | cycleColor, includeHoverEffects ? 'distribution-cycle-card' : '']"
    style="border-left: 4px solid var(--cycle-main)"
  >
    <div style="height: 14px; background-color: var(--cycle-main)"></div>
    <div class="p-3">
      <div class="d-flex justify-content-between align-items-center mb-1">
        <div class="d-flex align-items-center gap-2">
          <span class="fw-semibold fs-5">
            @if (displayVoucherProgramName) {
              <span>{{ cycle()!.voucherProgramName }} - </span>
            }
            {{ cycle() ? cycle()!.name : 'New Cycle' }}</span
          >
        </div>
        <div class="d-flex align-self-start">
          <span class="badge" [ngClass]="statusClass">{{ cycle()!.statusString }}</span>
        </div>
      </div>
      @if (cycle()!.description) {
        <div class="fs-6 mb-1 fw-bold fst-italic">{{ cycle()!.description }}</div>
      }
      <div class="small mb-1">
        Funding Limit: <span class="fw-bold">{{ cycle()!.fundingLimit | currency }}</span>
      </div>
      <div class="small mb-1">
        {{ cycle()!.distributionTypeString }}, Distributed by {{ cycle()!.distributedByString }}
      </div>

      <div class="small mb-2">
        {{ cycle()!.startDate | date: 'M/d/yyyy' }} &ndash; {{ cycle()!.endDate | date: 'M/d/yyyy' }}
      </div>
      @if (cycle()!.fundingLimit > 0) {
        <div class="progress position-relative border border-primary" style="height: 20px">
          <div class="progress-bar progress-bar-primary-100" role="progressbar" [style.width.%]="allocatedPct"></div>
          <div
            class="progress-bar progress-bar-primary-300 position-absolute top-0 start-0 h-100"
            role="progressbar"
            [style.width.%]="currentAssignedPct"
          ></div>
          <div
            class="progress-bar progress-bar-success-300 position-absolute top-0 start-0 h-100"
            role="progressbar"
            [style.width.%]="redeemedPct"
          ></div>
          <span
            class="position-absolute w-100 text-center fw-semibold text-primary"
            style="bottom: 5px; font-size: 0.9rem"
          >
            <span certTooltip="Redeemed Amount">{{ cycle()!.redeemedAmount | currency }}</span>
            /
            <span certTooltip="Assigned Amount">{{ cycle()!.currentAssignedAmount | currency }}</span>
            /
            <span certTooltip="Allocated Amount">{{ cycle()!.allocatedAmount | currency }}</span>
            /
            <span certTooltip="Unallocated Amount">{{ cycle()!.unallocatedAmount | currency }}</span>
          </span>
        </div>

        <!-- Row 4: Legend -->
        <div class="d-flex gap-3 mt-1 small">
          <span class="d-flex align-items-center gap-1">
            <span
              class="d-inline-block rounded-1 bg-success-300 border border-primary"
              style="width: 12px; height: 12px"
            ></span>
            Redeemed
          </span>
          <span class="d-flex align-items-center gap-1">
            <span
              class="d-inline-block rounded-1 bg-primary-300 border border-primary"
              style="width: 12px; height: 12px"
            ></span>
            Assigned
          </span>
          <span class="d-flex align-items-center gap-1">
            <span
              class="d-inline-block rounded-1 bg-primary-100 border border-primary"
              style="width: 12px; height: 12px"
            ></span>
            Allocated
          </span>
          <span class="d-flex align-items-center gap-1">
            <span
              class="d-inline-block rounded-1 bg-light border border-primary"
              style="width: 12px; height: 12px"
            ></span>
            Unallocated
          </span>
        </div>
      }
    </div>
  </div>
} @else {
  <ngx-skeleton-loader count="2" />
}
